export enum IntercomEvents {
  SignUpInProgress = 'signup-in-progress',
}
